import React from 'react';
import ReactTooltip from 'react-tooltip';
import Questionmark from '../../assets/img/question-mark.svg';
import convertToCurrency from '../../helpers/convertToCurrency';
import { segmentEvent } from '../../helpers/sendEvent';

export default function TooltipDueToday({
  place = 'right',
  title = 'Due today',
  data: { initialPayment, lcr, processingFee, nonLesableItems, shipping, tax, total, payFrequency, duePeriodPayment },
  classAdded,
}) {
  return (
    <>
      <img
        data-event="click"
        className={`k-tooltip-icon ${classAdded}`}
        data-tip
        data-for="dueTotal"
        role="tooltip"
        src={Questionmark}
        alt="Tooltip Due Today"
      />
      <ReactTooltip
        globalEventOff="click"
        clickable
        className="k-tooltip-theme"
        data-html
        id="dueTotal"
        place={place}
        effect="solid"
        afterShow={() => {
          segmentEvent('track', 'Due Today Details Clicked', {
            lease_payment: payFrequency,
            pay_frequency: duePeriodPayment,
            lcr,
          });
          // Monthly Payment, Down Payment, Pay Frequency, LCR
        }}
      >
        <div className="k-react-tooltip-totals">
          {title && (
            <div>
              <strong>{title}</strong>
            </div>
          )}
          {initialPayment === '0.00' && <div>Processing Fee: {convertToCurrency(processingFee)}</div>}
          {initialPayment !== '0.00' && <div>Initial payment: {convertToCurrency(initialPayment)}</div>}
          {lcr && <div>Lease Cost Reduction: {convertToCurrency(lcr)}</div>}
          <div>Shipping: {convertToCurrency(shipping)}</div>
          <div>Non-leasable items: {convertToCurrency(nonLesableItems)}</div>
          <div>Tax: {convertToCurrency(tax)}</div>
          <div>
            <strong>Total: {convertToCurrency(total) || '$0.00'}</strong>
          </div>
        </div>
      </ReactTooltip>
    </>
  );
}
